import React, { useState } from 'react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Autocomplete, Avatar, Button, Chip, CircularProgress, Container, CssBaseline, Grid, Switch, TextField, Typography, IconButton, Table, TableCell, TableContainer, TableHead, TableRow, Paper, TableBody } from "@mui/material";
import clsx from 'clsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars/index.js";
import { browserHistory } from '../../helpers/history';
import Api from "../../services/api";
import { Overlay } from "../../styles/global.js";
import { Styles } from '../../styles/material-styles';
import { withStyles } from '@mui/styles';
import { NotificationVariant } from 'src/utils/enums/notification-variants.enum';
import * as LLMEventService from "../../services/llmevent.service";
import * as LLMEventKeyWordService from "../../services/llmeventkeyword.service";
import styled from 'styled-components';
import { Delete } from '@mui/icons-material';

const itemInitialState = {
    id: null,
    name: '',
    system: false
};

const LLMEventEdit = (props) => {
    const { classes, intl } = props;

    const history = browserHistory;
    
    const { headerMenu, actionsHeaderMenu, userSession, llmevents } = useSelector(state => ({
        actionsHeaderMenu: state.actionsHeaderMenu,
        headerMenu: state.headerMenu,
        userSession: state.userSession,
        llmevents: state.llmevents
    }));

    const [item, setItem] = useState(itemInitialState);
    const [keyWords, setKeyWords] = useState([]);
    const [keyWordsRegistered, setKeyWordsRegistered] = useState([]);
  
    const [loading, setLoading] = useState(false);
    const [openNotification, setOpenNotification] = useState(false);
    const [notificationVariant, setNotificationVariant] = useState('error');
    const [notificationMessage, setNotificationMessage] = useState('');
    
    if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
        Api.logoff();
    }

    if (Api == null) {
        const language = props.match.params.lang;
        document.location.href=`/${language}/unavailable`;
    }
    
    const closeNotification = () => {
        setOpenNotification(false);
    };

    const showNotification = (message, variant = NotificationVariant.SUCCESS) => {
        setLoading(false);
        setOpenNotification(true);
        setNotificationVariant(variant);
        setNotificationMessage(message);
    };

    const handleInputChange = (e) => {
        const { name, value, checked } = e.target;
        let newValue = value;
        
        if (name === "system") {
            newValue = checked;
        }

        setItem(prev => ({
            ...prev,
            [name]: newValue
        }));
    };

    const handleDeleteKeyWord = async (keyword) => {
        setLoading(true);
        try {
            let keywordId = keyword?.id;
            if (keywordId) {
                const response = await LLMEventKeyWordService.deleteById(keyword?.id);   
                if (response?.success) {
                    await loadKeyWordsRegistered(item?.id);
                }
                else 
                {
                    showNotification("Não foi possível remover esta palavra chave.", NotificationVariant.ERROR);
                }
            }     
        } catch (err) {
            var message = err?.response?.data?.errors[0] ?? "Não foi possível remover a palavra chave.";
            showNotification(message, NotificationVariant.ERROR);
        } finally {
            setLoading(false);
        }
    }

    const loadKeyWordsRegistered = async (llmEventId) => {
        setLoading(true);
        try {
            let data = [];
            if (llmEventId) {
                const response = await LLMEventKeyWordService.getAllByEventId(llmEventId);
                if (response?.success) {
                    data = response?.data;
                }
            }
            setKeyWordsRegistered(data)
        } catch (err) {
            var message = err?.response?.data?.errors[0] ?? "Não foi possível recuperar as palavras chave.";
            showNotification(message, NotificationVariant.ERROR);
        } finally {
            setLoading(false);
        }
    }

    const loadInitialStateComponent = async () => {
        if (llmevents?.llmevents) {
            const currentItem = {
                id: llmevents.llmevents?.id,
                name: llmevents.llmevents?.name,
                system: llmevents.llmevents?.system,
            }
            setItem(currentItem);

            await loadKeyWordsRegistered(llmevents.llmevents?.id)
        }
        setKeyWords([]);
    }

    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();

        try {
        let payload = {...item, keywords: keyWords};

        const response = await LLMEventService.update(payload);

        if (response?.success) {
            setKeyWords([]);
            await loadKeyWordsRegistered(item?.id);
            showNotification(intl.formatMessage({ id: "update.success" }));
        } else {
            showNotification("Não foi possível salvar o registro.", NotificationVariant.ERROR);
        }
        } catch (err) {
            var message = err?.response?.data?.errors[0] ?? "Não foi possível salvar o registro.";
            showNotification(message, NotificationVariant.ERROR);
        } finally {
            setLoading(false);
        }
    }

    useState(() => {
        loadInitialStateComponent();
    }, [])
  
  return (
    <div className={classes.root}>
      <HeaderMenu />

      <main
        className={clsx(classes.content, {
          [classes.contentShift]: headerMenu.open,
        }, classes.actionsContent, {
          [classes.actionscontentShift]: actionsHeaderMenu.open,
        })}
      >
        <div className={classes.drawerHeader} />
        
        <Container component='main' maxWidth='md'>
          <CssBaseline />
          <div className={classes.paper} style={{ marginTop: 0 }}>
            <Grid container spacing={6}>
              <Grid item xs={12} sm={4}>
                <Button variant='outlined' color='primary' onClick={history.goBack}>
                  <FormattedMessage id="back" />
                </Button>
              </Grid>
              <Grid item xs={12} sm={8} />
            </Grid>

            <Avatar mt={7} style={{ backgroundColor: '#303f9f', color: 'white' }}>
              <SmartToyIcon />
            </Avatar>

            <Typography component='h1' variant='h5' mt={2}>
              {intl.formatMessage({ id: "llm.event.edit" })}
            </Typography>
             
            <form name='myForm' className={classes.form} onSubmit={handleSubmit} encType='multipart/form-data'>
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={12}>
                        <TextField
                            inputProps={{ maxLength: 250 }} 
                            fullWidth 
                            label={intl.formatMessage({id:"name"})} 
                            variant='outlined' 
                            name='name' 
                            onChange={handleInputChange} 
                            value={item.name} 
                            required 
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Autocomplete
                            multiple
                            id="tags-filled"
                            options={[]}
                            freeSolo
                            value={keyWords}
                            onChange={(event, newValue, reason) => {
                                setKeyWords(newValue);
                            }}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                    const { key, ...tagProps } = getTagProps({ index });
                                    return <Chip variant="outlined" label={option} key={key} {...tagProps} />;
                                })
                            }
                            renderInput={(params) => (
                                <TextField {...params} variant="filled" label={intl.formatMessage({ id: "keywords" })} />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                      <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                        <Grid item xs={12} sm={4}    >
                          <Button
                            type='submit'
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={classes.submit}
                          >
                            {<FormattedMessage id="save" />}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>

                </Grid>
            </form>

            {keyWordsRegistered?.length > 0 && (
                <StyledTableContainer component={Paper}>
                    <StyledTable>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>{intl.formatMessage({ id: "keyword" })}</StyledTableCell>
                                <StyledTableCell>{intl.formatMessage({ id: "delete" })}</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {keyWordsRegistered?.map(kw => (
                                <TableRow key={kw.id}>
                                    <StyledTableBodyCell>
                                        {kw?.keyword}
                                    </StyledTableBodyCell>
                                    
                                    <StyledTableBodyCell>
                                        <StyledIconButton delete onClick={() => handleDeleteKeyWord(kw)}>
                                            <Delete />
                                        </StyledIconButton>
                                    </StyledTableBodyCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </StyledTableContainer>
            )}
          </div>
          
          {loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}
          
          {openNotification && (
            <CustomizedSnackbars
              variant={notificationVariant}
              message={notificationMessage}
              isOpen={openNotification}
              toClose={closeNotification}
            />
          )}          
        </Container>
      </main>
    </div>
  );
};

const StyledTableContainer = styled(TableContainer)`
  width: 100%;
  margin: 20px auto;
`;

const StyledTable = styled(Table)`
  min-width: 650px;
  background-color: #ffffff;
`;

const StyledTableCell = styled(TableCell)`
  && {
    font-weight: bold;
    text-align: center;
    border: 1px solid #e0e0e0;  /* Linha de divisão */
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  && {
    text-align: center;
    border: 1px solid #e0e0e0;  /* Linha de divisão */
  }
`;

const StyledIconButton = styled(IconButton)`
  && {
    color: ${props => props.delete ? '#f44336' : '#687EFC'};
    &:hover {
      color: ${props => props.delete ? '#f44336' : '#3f51b4'};
    }
  }
`;


export default injectIntl(withStyles(Styles)(LLMEventEdit));